import CurrencySelector from '@/app/components/CurrencySelector'
import LanguageAndCurrencySelect from '@/app/components/LanguageAndCurrencyMobile'
import { Icons } from '@/app/components/ui/Icons'
import classNames from 'classnames'
import { pick } from 'lodash'
import { NextIntlClientProvider, useMessages } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'
import { FC } from 'react'

export interface Props {
	lang: string
	isMain?: boolean
	isSticky?: boolean
	children?: {
		middle?: React.ReactNode
		bottom?: React.ReactNode
	}
}

const Top: FC<Props> = (props) => {
	const { lang, isMain = false, children, isSticky } = props
	const messages = pick(useMessages(), ['Keywords', 'Header'])

	return (
		<div
			className={classNames('max-lg:bg-white container', {
				'py-3 lg:py-6 max-lg:rounded-4xl': !isMain,
				'max-lg:py-5': isMain,
			})}
		>
			<div className={classNames('flex justify-between items-center')}>
				<Link
					href={`/${lang}`}
					aria-label="Main Logo Link"
					className={'lg:hidden'}
				>
					<Icons.logoSmall className={classNames({ hidden: !isMain })} />
					<Icons.logoSmaller className={classNames({ hidden: isMain })} />
				</Link>
				<div className="hidden lg:block w-[234px]">
					<Link
						href={`/${lang}`}
						aria-label="Main Logo Link"
						className="inline-block"
					>
						<Icons.logoSmall className="lg:hidden" />
						{isMain ? (
							<>
								<Image
									src={'/images/logo.png'}
									width={130}
									height={40}
									alt="BestHotelsPrices Logo"
									unoptimized
									className="hidden xl:block"
								/>
								<Image
									src={'/images/logo-colored.png'}
									width={130}
									height={40}
									alt="BestHotelsPrices Logo"
									unoptimized
									className="xl:hidden"
								/>
							</>
						) : (
							<Image
								src={'/images/logo-colored.png'}
								width={106}
								height={52}
								alt="BestHotelsPrices Logo"
								unoptimized
							/>
						)}
					</Link>
				</div>
				{children?.middle}
				<NextIntlClientProvider locale={'en'} messages={messages}>
					<div className="lg:hidden">
						<LanguageAndCurrencySelect />
					</div>
					<div className="hidden lg:flex w-[187px] justify-end">
						{/* <LanguageSelector
							isMainPage={isMain}
							isSticky={isSticky as boolean}
						/> */}
						<CurrencySelector
							isMainPage={isMain}
							isSticky={isSticky as boolean}
						/>
					</div>
				</NextIntlClientProvider>
			</div>
			{children?.bottom}
		</div>
	)
}

export default Top
